/**
 * Legacy auth.ts - Maintained for backward compatibility
 * 
 * This file re-exports the new production-ready architecture:
 * - AuthService (focused on authentication operations)
 * - TokenManager (secure token lifecycle management)  
 * - AuthenticatedClient (HTTP requests with auto-refresh)
 * 
 * Import the specific services directly for new code:
 * import { AuthService } from './authService';
 * import { TokenManager } from './tokenManager';
 * import { AuthenticatedClient } from './authenticatedClient';
 */

// Re-export production services
export { AuthService } from './authService';
export { TokenManager } from './tokenManager';
export { AuthenticatedClient } from './authenticatedClient';

// Re-export types for backward compatibility
export type { AuthState, UserProfile } from './authService';